/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ItemTypeConstants } from './ItemTypeConstants';
import {
    ItemTypeConstantsFromJSON,
    ItemTypeConstantsFromJSONTyped,
    ItemTypeConstantsToJSON,
} from './ItemTypeConstants';

/**
 * ReferenceItem: used in selection menus, the refId allows to convert back to the corresponding Java object
 * @export
 * @interface ReferenceItem
 */
export interface ReferenceItem {
    /**
     * 
     * @type {ItemTypeConstants}
     * @memberof ReferenceItem
     */
    type: ItemTypeConstants;
    /**
     * Optional label, if given replaces value to be displayed in the dropdown, but never as value in the form.
     * @type {string}
     * @memberof ReferenceItem
     */
    label?: string;
    /**
     * Value as displayed in the form after it has been picked from the dropdown
     * @type {any}
     * @memberof ReferenceItem
     */
    value?: any;
    /**
     * 
     * @type {string}
     * @memberof ReferenceItem
     */
    refId: string;
}

/**
 * Check if a given object implements the ReferenceItem interface.
 */
export function instanceOfReferenceItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "refId" in value;

    return isInstance;
}

export function ReferenceItemFromJSON(json: any): ReferenceItem {
    return ReferenceItemFromJSONTyped(json, false);
}

export function ReferenceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferenceItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': ItemTypeConstantsFromJSON(json['type']),
        'label': !exists(json, 'label') ? undefined : json['label'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'refId': json['refId'],
    };
}

export function ReferenceItemToJSON(value?: ReferenceItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': ItemTypeConstantsToJSON(value.type),
        'label': value.label,
        'value': value.value,
        'refId': value.refId,
    };
}

